import React, { createContext, PropsWithChildren, useContext, useMemo } from 'react';
import { SetURLSearchParams, useSearchParams } from 'react-router-dom';

// Define the shape of the context
interface IQueryParamsContextProps {
	queryParams?: string | null;
	setSearchParams: SetURLSearchParams;
}

// Create the context
const QueryParamsContext = createContext<IQueryParamsContextProps | undefined>(undefined);

// Custom hook to use the context
export const useQueryParams = (): IQueryParamsContextProps => {
	const context = useContext(QueryParamsContext);
	if (!context) {
		throw new Error('useQueryParams must be used within a QueryParamsProvider');
	}
	return context;
};

export const QueryParamsProvider: React.FC<PropsWithChildren> = ({ children }) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const queryParams = useMemo(() => searchParams.get('vendor'), [searchParams]);

	return (
		<QueryParamsContext.Provider value={{ queryParams, setSearchParams }}>{children}</QueryParamsContext.Provider>
	);
};
